import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
 
  Radio,
  RadioGroup,
 
} from "@mui/material";
// import styles from "styles/component/Popper.module.scss";
// import styles from "styles/component/FcbPopOver.module.scss";
import styles from "styles/component/CustomCoursePopOver.module.scss";


// import asset from "json/assets";
import {fcbMarkerType,   } from "json/constants";
import { useSelectedCourseZoneType } from "hooks/CourseMapDetails";

export const FcbPopOverComponent = (props) => {
  const {
    markerType,
    handleChangeMarkerType,
    selectedMarkerMod2,
    // handelChangeMarkerColor,
    errorMsg,
    handleSave,
    errorComponent
  } = props;
 
  const zoneType = useSelectedCourseZoneType();
 const isDataAdded=(marker)=>{
  let data=zoneType?.data
  return data?.some((o)=>o.place===marker)

  // return false
 }
  return (
    <Box className={styles.popover_body_new}>
      <FormControl>
        <FormLabel id="demo-radio-buttons-group-label">SELECT TYPE</FormLabel>
        <RadioGroup
       className={styles.marker_option}
       aria-labelledby="demo-radio-buttons-group-label"
       // defaultValue="FLAG"
       name="radio-buttons-group"
       value={markerType}
       onChange={handleChangeMarkerType}
        >
          {fcbMarkerType?.map((marker, index) => (
            <FormControlLabel
              value={marker.value}
              control={<Radio checked={marker.value === markerType} />}
              label={marker.label}
              key={index}
              disabled={isDataAdded(marker.value)}
              style={{background: isDataAdded(marker.value) ? '#d6d4ce':'none'}}
            />
          ))}
        </RadioGroup>
 
      </FormControl>
      {errorMsg && errorComponent()}
      <Box className={styles.popover_ftr}>
        <Button
          to={"#"}
          className={styles.blue_btn}
          onClick={() => handleSave()}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};
